/*!
* Speaker order form
*/
/* globals grecaptcha */

import {submitHandler} from '../utils/submit-handler';
import messages from '../messages/common';
import {showResult} from '../utils/response-notice';

const wrapForm = '.modal--speaker';
const message = messages();

/**
 * Validate adn send form
 */
let initValidate = ($wrapElem) => {
    $wrapElem.find('form').validate({
        focusCleanup: true,
        ignore: '[name="order[text]"]',
        rules: {
            'order[name]': {
                required: true,
            },
            'order[last_name]': {
                required: true,
            },
            'order[organization]': {
                required: true,
            },
            'order[position]': {
                required: true,
            },
            'order[phone]': {
                required: true,
            },
            'order[email]': {
                required: true,
                email: true,
            },
            'order[note]': {
                required: true,
            },
        },
        messages: {
            'order[name]': {
                required: message.empty,
            },
            'order[last_name]': {
                required: message.empty,
            },
            'order[organization]': {
                required: message.empty,
            },
            'order[position]': {
                required: message.empty,
            },
            'order[phone]': {
                required: message.empty,
            },
            'order[email]': {
                required: message.empty,
                email: message.incorrectEmail,
            },
            'order[note]': {
                required: message.empty,
            },
        },
        submitHandler() {
            let $form = $wrapElem.find('form');

            submitHandler($form).then((json) => {
                if (json.success) {
                    showResult($form, json, {
                        title: 'Спасибо!',
                        body: 'Ваше сообщение успешно отправлено!',
                    });
                } else {
                    showResult($form, json, {});
                }

                grecaptcha.reset();
                grecaptcha.execute();
            });
        },
        errorClass: 'invalid',
        errorPlacement(error, Element) {
            error.addClass('error');
            error.wrapInner($('<div>').addClass('error-inner'));
            Element.after(error);
        },
    });
};

/**
 * Init subscribe form
 */
let init = () => {
    let $wrapElem = $(wrapForm);

    if (!$wrapElem.length) {
        return;
    }

    $wrapElem.each((i, elem) => {
        initValidate($(elem));
    });
};

export {init as initSpeakerOrder};
